import React from 'react';

const TruncarTexto = ({ texto, limite }) => {
  if (!texto || texto.length <= limite) {
    return <span>{texto}</span>;
  }

  const textoTruncado = texto.slice(0, limite) + '...';

  return (
    <span title={texto}>
      {textoTruncado}
    </span>
  );
};
export default TruncarTexto;